<template>
    <main>
        <form class="form-signin row" @submit="submit">
            <div class="col-md-4">
            </div>
            <div class="col-md-8">
                <div class="text-center"><img src="./../assets/img/logo4.png" class="mb-2 mb-md-3" /></div>
                <div id="loginBlock">
                    <input type="text" id="login" name="login" placeholder="Логин" v-model="login" class="form-control mb-2" required autofocus>
                </div>
                <div id="passwordBlock">
                    <input type="password" id="password" class="form-control mb-2" placeholder="Пароль" v-model="password" required>
                </div>
                <div class="checkbox mb-2 remember">
                    <label>
                        <input type="checkbox" name="remember" value="rem" id="rem" v-model="remember"> Запомнить
                    </label>
                </div>
                <button class="btn btn-lg btn-primary btn-block mb-2" type="submit">Войти</button>
                <div class="checkbox mb-2 foroom">
                    <label>
                        <input type="checkbox" name="sale_foroom" value="sf" id="sf" v-model="invitation"> Отправить мне приглашение в sale.foroom.ru
                    </label>
                </div>
                <a href="/forgot">Восстановить пароль</a>
            </div>
        </form>
    </main>
</template>

<script>
    import makePost from '../js/makePost';

    export default {
        name: "Login",
        props: ['site', 'foroomLogin', 'foroomPassword'],
        metaInfo: {
            title: 'Вход',
            titleTemplate: '%s - sale.katris'
        },
        data() {
            return {
                login: '',
                password: '',
                remember: false,
                invitation: false
            }
        },
        created() {
            let self = this;

            if (self.site) {
                self.$router.push({path: '/login'});

                if (self.site == 'foroom') {
                    self.login = self.foroomLogin;
                    self.password = self.foroomPassword;

                    self.submit();
                }
            }
        },
        methods: {
            submit: function(e) {
                let self = this;
                if (this.login != '' && this.password != '') {
                    let data = {
                        'login': this.login, 'password': this.password, 'invitation': this.invitation
                    };

                    if (this.site) data.site = self.site;

                    makePost('katrisService', 'login', data, null, function(response) {
                        // console.log(response)
                        if (response.status === 'OK') {
                            response = JSON.parse(response.data);

                            makePost('katrisService', 'checkCounteragentStatus', {counteragentID: response.user.contragentId}, null, function(response2) {
                                if (response2.status === 'OK') {
                                    if (response2.data.status != 4 || response.user.katrisUser == 1) {
                                        response.user.exStatus = response2.data.status;

                                        if (response.user.exStatus == undefined) response.user.exStatus = 0

                                        // response.user.Deal = 1; //Тест!
                                        // response.user.accDealerSale = 1; //Тест!

                                        self.$session.start();
                                        self.$session.set('jwt', response.token);
                                        self.$session.set('user', response.user);

                                        // if (self.login === 'artcat') {
                                        //     self.$session.set('user', JSON.parse('{"loginId":"2309","login":"Костя","password":"b2862a950621c79085a8bb08067324cb","salt":"0KKR2RuHVl","contragentId":"2559","payerId":"0","manager":"0","katrisUser":"0","newType":"1","parent":"1612","wantedName":"ЧТУП \\"Межароль\\"","phone":"","mobilePhone":"","showMobile":null,"email":"melyanets@inbox.ru","name":"","lastname":"","patronymic":"","post":"","numericPost":"0","enabled":"1","lastEnter":"1769520698","creatorLogin":"","editorLogin":"","newNews":"0","license":"1","created":"1365059950","changed":"0","accGP":"1","accKomplect":"1","accPrice":"0","accPriceGp":"1","accPriceKompl":"1","accPriceDiscount":"1","accElse":"1","accChPayers":"1","accBalans":"1","accPayGrafik":"1","accPayGrafikNotification":"1","accOrders":"1","accOrdersOtherPayers":"0","accAvailablePayers":"","timezone":"3","deleted":"0","jabberAccount":null, "Deal": "1"}'));
                                        //     self.$session.set('user', JSON.parse('{ "loginId": 1917, "login": "688174", "password": "24ccd5cf700057abd99733dc48fdeb61", "salt": "7vT1fJCEpA", "contragentId": 74, "payerId": 74, "manager": 0, "katrisUser": null, "newType": 0, "parent": 0, "wantedName": "ИП Снежков В.И.", "phone": "", "mobilePhone": "", "showMobile": null, "email": "aprel-design@mail.ru", "name": "Василий", "lastname": "Снежков", "patronymic": "Иванович", "post": "", "numericPost": 0, "enabled": 0, "lastEnter": 1730364478, "creatorLogin": "731387", "editorLogin": "688174", "newNews": 1, "license": 1, "created": 1339055290, "changed": 1457952182, "accGP": 1, "accKomplect": 1, "accPrice": 0, "accPriceGp": 1, "accPriceKompl": 1, "accPriceDiscount": 1, "accElse": 1, "accChPayers": 1, "accBalans": 1, "accPayGrafik": 1, "accPayGrafikNotification": 1, "accOrders": 1, "accOrdersOtherPayers": 0, "accAvailablePayers": "", "accDealerSale": 1, "timezone": 0, "deleted": 0, "jabberAccount": null, "Deal": "1" }'));
                                        // }

                                        document.location.href = '/'
                                    } else {
                                        alert('Учетная запись заблокирована');
                                    }
                                } else {
                                    alert('Ошибка авторизации');
                                }
                            });
                        } else {
                            alert('Ошибка авторизации');
                        }
                    });
                } else {
                    alert('Поля заполнены не верно');
                }
                e.preventDefault();
            }
        }
    }
</script>

<style scoped>
    @import "./../assets/css/newLogin.css";

    .form-signin {
        width: 600px;
        /*height: 400px;*/
        padding: 15px;
        margin: auto;

        border-radius: 21px;

        -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,.8);
        box-shadow: 0 0 10px 0 rgba(0,0,0,.8);
        -webkit-box-shadow: 5px 5px 20px 0px rgba(0,0,0,.6);
        box-shadow: 5px 5px 20px 0px rgba(0,0,0,.6);

        background-image: url("./../assets/img/logo-katris.png");
        background-repeat: no-repeat;
        background-size: 30%;
    }

    /*@import "./../assets/css/login.css";*/
</style>
